<template>
	<nio-popup
		v-model="visible"
		:round="false"
		:closeable="false"
		:safeAreaInsetBottom="true"
		:closeOnClickOverlay="true"
		:position="'bottom'"
		@closed="close"
	>
		<div
			class="card-popup"
			:style="{
				paddingBottom: safeInsetBottom + 'px'
			}"
		>
			<div class="card-popup__close">
				<div class="card-popup__close-title">
					请选择
				</div>
				<div>
					<nio-icon
						:name="'icon_close_s'"
						style="height:24px"
						:color="'#040B29'"
						:size="24"
						@click="close"
					/>
				</div>
			</div>
			<div
				v-for="(item, index) in options"
				:key="item.value"
				:class="
					checked && checked.value === item.value ? 'card-block card-block__checked' : 'card-block'
				"
				@click="checkBox(index, item)"
			>
				<div class="card-block__name">{{ item.name }}</div>
				<div class="card-block__checked-icon" v-if="checked && checked.value === item.value">
					<nio-icon
						:name="'icon_check_2xs'"
						style="height:16px"
						:color="'#00BEBE;'"
						:size="16"
						@click="close"
					/>
				</div>
			</div>
		</div>
	</nio-popup>
</template>
<script>
import { getSafeInsetBottom } from '@/util/unit-transfer'
export default {
	name: 'card-popup',
	props: {
		cardPopupVisible: {
			type: Boolean,
			default: false
		},
		selectValue: {
			type: Object
		},
		options: {
			type: Array
		}
	},

	data() {
		return {
			visible: this.cardPopupVisible,
			checkedIndex: null,
			safeInsetBottom: getSafeInsetBottom(),
			checked: this.selectValue,
			headerHeight: 0
		}
	},
	methods: {
		close() {
			this.$emit('update:selectValue', this.checked)
			this.$emit('update:cardPopupVisible', false)
		},
		checkBox(index, item) {
			this.checkedIndex = index
			this.checked = item
			this.visible = false
		}
	},
	watch: {
		cardPopupVisible(val) {
			this.visible = val
		},
		selectValue(val) {
			this.checked = val
		}
	}
}
</script>
<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';
.card-popup {
	//   height: 60vh;
	&__close {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 50px;
		padding-left: 20px;
		padding-right: 20px;
		justify-content: space-between;
		&-title {
			@include subtitle_2(1.4, 700, false);
		}
	}
	&-btn {
		padding: 15px 15px;
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: white;
	}
}
.card-block {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding: 20px 20px;
	color: $text_primary;
	&__checked {
		color: #00bebe;
	}
	&__name {
		@include body_1(1.5, 500, false);
	}
}
</style>
